<template lang="pug">
  section.content(
    :class='classList'
  )
    .content__main
      transition(
        name='fade'
        mode='out-in'
      )
        .content__genres-list(
          v-if='genresListVisible && !queueVisible'
          key='genresList'
        )
          GenresList

        .content__queue(
          v-if='queueVisible'
          key='queue'
        )
          Queue

        .content__section(
          v-if='!queueVisible && !genresListVisible'
          key='content'
        )
          slot

          .content__promo
            Promo(
              :type='"mobile"'
            )

          .content__footer(
            v-if='footer'
          )
            Footer

</template>

<script>
import Queue from "@/components/Queue/Queue";
import GenresList from "@/components/GenresList/GenresList";
import Promo from "@/components/Promo/Promo";
import Footer from "@/components/Footer/Footer";

import { mapGetters } from "vuex";

export default {
  name: "DefaultLayout",
  props: {
    footer: {
      type: Boolean,
      default: true
    }
  },
  components: {
    Queue,
    GenresList,
    Promo,
    Footer
  },
  watch: {
    queueVisible() {
      if (this.queueVisible && this.genresListVisible) {
        this.genresList.hide();
      }
    }
  },
  computed: {
    ...mapGetters({
      queueVisible: "page/queue",
      genresList: "page/genresList",
      status: "page/status"
    }),
    genresListVisible() {
      return this.genresList && this.genresList.visible;
    },
    classList() {
      return {
        "has-genrelist": this.genresListVisible,
        "has-queue": this.queueVisible,
        [`is-${this.status}`]: this.status
      };
    }
  }
};
</script>
